import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import router from 'next/router';
import { DSButton, DSDialog, DSHeading, DSText } from '@stihl-design-system/components';

import { link } from '@phoenix/core/frontend/shared/util/navigation/link.utils';

import { useNotifications } from './use-notifications';

export const ServiceReminderPopUp: FC = () => {
  const { t } = useTranslation('shared');
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const { notification, onDismiss } = useNotifications();
  const { id, productId, serialNumber } = notification || {};

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (id) {
      timeoutId = setTimeout(() => {
        setDialogIsOpen(true);
      }, 750);
    }

    return () => {
      timeoutId && clearTimeout(timeoutId);
    };
  }, [id]);

  const closeDialog = () => {
    setDialogIsOpen(false);
    onDismiss(id);
  };

  const onAccept = () => router.replace(link(`/tool-shed/service-appointment?toolId=${productId}`)).then(closeDialog);

  return (
    <DSDialog
      isOpen={dialogIsOpen}
      onClose={closeDialog}
      hideCloseButton={true}
      disableBackdropClose={true}
      data-testid="service-reminder-pop-up"
      header={<DSHeading tag="h3">{t('serviceReminderPopUp_headline')}</DSHeading>}
      footer={
        <div className="flex flex-col tablet:flex-row gap-4">
          <DSButton type="button" className="w-full tablet:w-fit" onClick={onAccept} data-testid="make-appointment-btn">
            {t('serviceReminderPopUp_button_makeAppointment')}
          </DSButton>
          <DSButton type="button" className="w-full tablet:w-fit" variant="outline" onClick={closeDialog} data-testid="no-thanks-btn">
            {t('serviceReminderPopUp_button_noThanks')}
          </DSButton>
        </div>
      }
    >
      <DSText>{t('serviceReminderPopUp_subHeadline', { serialNumber })}</DSText>
    </DSDialog>
  );
};
